import React, { useEffect, useState, useRef} from 'react'
import "./data-table.css";
import axios from 'axios';
import Swal from "sweetalert2";
import { FaLocationDot, FaBuilding, FaPlaneArrival, FaBox, FaGear, FaClock, FaGhost, FaReceipt, FaAngleDown } from "react-icons/fa6";
import Doughnut from "../../../components/charts/Doughnut/Doughnut";
import BarChart from "../../../components/charts/bar/bar-chart";
import Chart from 'chart.js/auto';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function DataTable() {
    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [estaciones, Setestaciones] = useState(0);
    const [mexDom, SetmexDom] = useState(0);
    const [mexExpo, SetmexExpo] = useState(0);
    const [variacion, Setvariacion] = useState(0);
    const [_24h, Set_24h] = useState(0);
    const [_60m, Set_60m] = useState(0);
    const [fantasmas, Setfantasmas] = useState(0);
    const [duplicadas, Setduplicadas] = useState(0);
    const [operados, Setoperados] = useState(0);
    const [vuelos, Setvuelos] = useState(0);
    const [facturados, Setfacturados] = useState(0);
    const [noFacturados, SetnoFacturados] = useState(0);
    const [efectividad, Setefectividad] = useState(0);
    const [semanas_num, SetSemanas] = useState([]);
    const [weekAccumulated, setWeekAccumulated] = useState(false);
    const [resultsArray, setResultsArray] = useState([]);
    const [params, setParams] = useState({ week: '', year: '' });
    const [query, setQuery] = useState(window.location.search);
    
    const showData = () => {
        setWeekAccumulated(!weekAccumulated);
    }

    const getDashboard = async () => {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        // Obtener los parámetros de la URL
        const week = searchParams.get('week');
        const year = searchParams.get('year');
        let variables = "";
        if(week && year){
            variables = [{
                'week': week,
                'year': year
            }];
        }
        const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/dashboard`, {
            params:{
                'week': week,
                'year': year
            },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        });
        if (res.data.code === 1){
          setDates(res.data.dates)
          setLoading(false)
        }
        
      } catch (error) {
        Swal.fire("Error", "Hubo un error", "error");
        setLoading(true);
      }
    };

    useEffect(() => {
        const fetchDashboardAndLogDates = async () => {
            await getDashboard();  // Espera a que getDashboard se complete
        };
        let semanas_arr = [];
        fetchDashboardAndLogDates();  // Llama a la función asíncrona
    }, []);  

    useEffect(() => {
        if (dates.length > 0 && !loading) {
            let delay = 0;
            setResultsArray([]); // Limpiar resultados de forma previa

            async function fetchDataSequentially() {
                for (const date of dates) {
                    let semanas = [{
                        'num_semana': date.num_semana,
                        'last_year_digit': date.last_year_digit,
                        'start_date': date.start_date,
                        'end_date': date.end_date,
                    }];

                    await new Promise(resolve => setTimeout(resolve, delay)); // Espera
                    delay += 80; // Incrementar el delay

                    try {
                        const result = await axios.post(
                            `${process.env.REACT_APP_URL_BACKEND}/dashboard/data`,
                            semanas,
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                                },
                            }
                        );

                        let pedro = date.columna;
                        Setfacturados(prevFacturados => prevFacturados + parseFloat(result.data.totales_semanas[0].vuelos_sem_actual_facturados_esta_semana));
                        Setoperados(prevOperados => prevOperados + parseFloat(result.data.totales_semanas[0].vuelos_totales_semana));
                        SetnoFacturados(prevFacturados => prevFacturados + parseFloat(result.data.totales_semanas[0].vuelos_sem_actual_no_facturados_esta_semana));
                        Setestaciones(prevEstaciones => prevEstaciones + parseFloat(result.data.totales_semanas[0].sem_actual_estaciones_este_vuelo));
                        SetmexDom(prevmexDom => prevmexDom + parseFloat(result.data.totales_semanas[0].sem_actual_mex_dom_esta_semana));
                        SetmexExpo(prevmexExpo => prevmexExpo + parseFloat(result.data.totales_semanas[0].sem_actual_mex_expo_esta_semana));
                        Setvariacion(prevvariacion => prevvariacion + parseFloat(result.data.totales_semanas[0].variacion_peso_sem_actual_esta_semana));
                        Set_24h(prev_24h => prev_24h + parseFloat(result.data.totales_semanas[0].tiempos_24_esta_semana));
                        Set_60m(prev_60m => prev_60m + parseFloat(result.data.totales_semanas[0].tiempos_60_esta_semana));
                        Setfantasmas(prevfantasmas => prevfantasmas + parseFloat(result.data.totales_semanas[0].tiempos_fantasma_esta_semana));
                        Setduplicadas(prevduplicadas => prevduplicadas + parseFloat(result.data.totales_semanas[0].total_duplicadas_semana_esta_semana));
                        setResultsArray(prevResultsArray => [
                            ...prevResultsArray,
                            result.data.totales_semanas[0].pe_
                        ]);

                        document.getElementById('vf_' + pedro).textContent = result.data.totales_semanas[0].vuelos_sem_actual_facturados_esta_semana;
                        document.getElementById('vo_' + pedro).textContent = result.data.totales_semanas[0].vuelos_totales_semana;
                        document.getElementById('vnf_' + pedro).textContent = result.data.totales_semanas[0].vuelos_sem_actual_no_facturados_esta_semana;
                        document.getElementById('est_' + pedro).textContent = result.data.totales_semanas[0].sem_actual_estaciones_este_vuelo;
                        document.getElementById('mex_dom_' + pedro).textContent = result.data.totales_semanas[0].sem_actual_mex_dom_esta_semana;
                        document.getElementById('mex_expo' + pedro).textContent = result.data.totales_semanas[0].sem_actual_mex_expo_esta_semana;
                        document.getElementById('impo_' + pedro).textContent = result.data.totales_semanas[0].sem_actual_impo_esta_semana;
                        document.getElementById('vap_' + pedro).textContent = result.data.totales_semanas[0].variacion_peso_sem_actual_esta_semana;
                        document.getElementById('entiempo_' + pedro).textContent = result.data.totales_semanas[0].tiempos_en_tiempo_esta_semana;
                        document.getElementById('24h_' + pedro).textContent = result.data.totales_semanas[0].tiempos_24_esta_semana;
                        document.getElementById('60m_' + pedro).textContent = result.data.totales_semanas[0].tiempos_60_esta_semana;
                        document.getElementById('fant_' + pedro).textContent = result.data.totales_semanas[0].tiempos_fantasma_esta_semana;
                        document.getElementById('fd_' + pedro).textContent = result.data.totales_semanas[0].total_duplicadas_semana_esta_semana;
                        document.getElementById('vfp_' + pedro).textContent = result.data.totales_semanas[0].vfp;
                        document.getElementById('pe_' + pedro).textContent = result.data.totales_semanas[0].pe_ + '%';
                    } catch (error) {
                        console.error('Error en la solicitud:', error);
                    }
                }
            }

            fetchDataSequentially();
        }
    }, [dates]);

    useEffect(() => {
        if (operados > 0) {
            let efe = ((facturados - (variacion + fantasmas + _24h + _60m)) / operados) * 100
            efe = efe.toFixed(2);
            let total_vuelos_per = (facturados*100)/operados;
            total_vuelos_per = total_vuelos_per.toFixed(2);
            Setvuelos(total_vuelos_per+'%')
            Setefectividad(efe+'%');
        }
    }, [facturados, variacion, fantasmas, _24h, _60m, operados]);

    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) {
          chartInstance.current.destroy(); // Destruir el gráfico existente
        }
    
        const ctx = chartRef.current.getContext('2d');
    
        chartInstance.current = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Facturados', 'No Facturados'],
            datasets: [{
              label: '',
              data: [facturados, noFacturados],
              backgroundColor: ['#1942A1', '#A5ACBB'],
              hoverOffset: 0
            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });

        return () => {
            if (chartInstance.current) {
              chartInstance.current.destroy();
            }
        };
    }, [facturados, noFacturados]);

    const chartRef2 = useRef(null);
    const chartInstance2 = useRef(null);

    useEffect(() => {
        if(chartInstance2.current) {
            chartInstance2.current.destroy();
        }
        const ctx = chartRef2.current.getContext('2d');
        chartInstance2.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: dates.map((date) => `${date.last_year_digit}${date.num_semana.toString().padStart(2, '0')}`),
                datasets: [{
                    label: '',
                    data: resultsArray.map((res) => res),
                    backgroundColor: ['#31d4be', '#d4c131'],
                    hoverOffset: 0
                }]
            },
            options: {
                scales: {
                    y: {
                      beginAtZero: true
                    }
                }
            }
        });

        return () => {
            if(chartInstance2.current) {
                chartInstance2.current.destroy();
            }
        };
    }, [resultsArray]);
    
    const exportToExcel = async () => {
        let data = [];
        let rowData = [];

        rowData.push('Semanas');
        rowData.push('Vuelos operados');
        rowData.push('Vuelos facturados');
        rowData.push('% Vuelos facturados');
        rowData.push('Vuelos NO facturados');
        rowData.push('Estaciones');
        rowData.push('MEX Dom');
        rowData.push('MEX Expo');
        rowData.push('Impo');
        rowData.push('Variación en peso');
        rowData.push('En tiempo');
        rowData.push('+24 hrs');
        rowData.push('+60 min');
        rowData.push('Fantasmas');
        rowData.push('Facturas duplicadas');
        rowData.push('% Efectividad');
        data.push(rowData);

        // Loop through months
        for (let o = 1; o < 13; o++) {
            let rowData = [];
            rowData.push(parseFloat(document.getElementById(`head${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`vo_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`vf_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`vfp_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`vnf_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`est_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`mex_dom_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`mex_expo${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`impo_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`vap_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`entiempo_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`24h_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`60m_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`fant_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`fd_${o}`).textContent));
            rowData.push(parseFloat(document.getElementById(`pe_${o}`).textContent));

            data.push(rowData);
        }

        // Transponer la matriz
        const transposedData = transposeArray(data);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Tablero CFDI');

        // Añadir datos a la hoja transpuestos
        transposedData.forEach((row, index) => {
            worksheet.addRow(row);
        });

        // Estilo para fondo azul y texto blanco
        const headerStyle = {
            font: { color: { argb: 'FFFFFFFF' }, bold: true }, // Texto blanco
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '67b4dc' } }, // Fondo azul
            alignment: { horizontal: 'center', vertical: 'middle' }
        };

        // Aplicar estilo a A1:M1 (transpuesto ahora es la columna 1)
        for (let row = 1; row <= transposedData.length; row++) {  
            worksheet.getCell(row, 1).style = headerStyle;
        }

        // Aplicar estilo a A1:A16 (transpuesto ahora es la fila 1)
        for (let col = 1; col <= transposedData[0].length; col++) {
            worksheet.getCell(1, col).style = headerStyle;
        }
        for (let col = 2; col <= 13; col++) {  // B es 2 y M es 13
            worksheet.getCell(4, col).numFmt = '0.00"%"';  // Fila 4
            worksheet.getCell(16, col).numFmt = '0.00"%"'; // Fila 16
        }
        
        // Ajustar columnas para que se ajusten al contenido
        worksheet.columns.forEach(column => {
            column.width = 20;
        });

        // Generar el archivo Excel y descargarlo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, 'tablero_cfdi.xlsx');
    };

    // Función para transponer la matriz
    const transposeArray = (array) => {
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    };

    useEffect(() => {
        setQuery(window.location.search);
        getDashboard(); // Ejecutar cuando cambia la URL
      }, [window.location.search]); 

    return(
        <div className="container">
            <div className="dd-icons-container">

                <div className="icon-box">
                    <span className="icon">
                        <FaLocationDot />
                    </span>
                    <p className="txt-title">ESTACIONES</p>
                    <p>{ estaciones }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaBuilding />
                    </span>
                    <p className="txt-title">MEX DOM</p>
                    <p>{ mexDom }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaPlaneArrival />
                    </span>
                    <p className="txt-title">MEX EXPO</p>
                    <p>{ mexExpo }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaBox />
                    </span>
                    <p className="txt-title">VARIACION EN PESO</p>
                    <p>{ variacion }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaGear />
                    </span>
                    <p className="txt-title">+24 HRS</p>
                    <p>{ _24h }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaClock />
                    </span>
                    <p className="txt-title">+60 MIN</p>
                    <p>{ _60m }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaGhost />
                    </span>
                    <p className="txt-title">FANTASMAS</p>
                    <p>{ fantasmas }</p>
                </div>

                <div className="icon-box">
                    <span className="icon">
                        <FaReceipt />
                    </span>
                    <p className="txt-title">FACTURAS DUPLICADAS</p>
                    <p>{ duplicadas }</p>
                </div>

            </div> 

            <div className={"dd-container-text bg-gradient-blue " + (!weekAccumulated ? "dd-hidden" : "dd-show")}>
                <div className="dd-title" onClick={showData}>
                    <p>ACUMULADO POR SEMANA</p> <span className={!weekAccumulated ? "icon-down" : "icon-up"}><FaAngleDown /></span>
                </div>

                <div className="dd-cont-details">
                    <div className="dd-text-details">
                        <p>Operados</p>
                        <p>{ operados }</p>
                    </div>
                    <div className="dd-text-details">
                        <p>Vuelos</p>
                        <p>{ vuelos }</p>
                    </div>
                    <div className="dd-text-details">
                        <p>Facturados</p>
                        <p>{ facturados }</p>
                    </div>
                    <div className="dd-text-details">
                        <p>No facturados</p>
                        <p>{ noFacturados }</p>
                    </div>
                    <div className="dd-text-details">
                        <p>% Efectividad</p>
                        <p>{ efectividad }</p>
                    </div>
                </div>
            </div>
        

        
            <div className="dt-table-header">
                <p>COMPLEMENTO CARTA PORTE</p>
                <button className="btn-amc-blue" onClick={exportToExcel}>Exportar xls</button>
            </div>

            <div className="td-container-table">
                <div className="td-static-row">
                    <p className="title-row bg-gray">Vuelos operados</p>
                    <p className="title-row">Vuelos facturados</p>
                    <p className="title-row bg-gray">% Vuelos facturados</p>
                    <p className="title-row">Vuelos NO</p>
                    <p className="title-row bg-gray">Estaciones</p>
                    <p className="title-row">MEX Dom</p>
                    <p className="title-row bg-gray">MEX Expo</p>
                    <p className="title-row">Impo</p>
                    <p className="title-row bg-gray">Variacion en peso</p>
                    <p className="title-row">En tiempo</p>
                    <p className="title-row bg-gray">+24 hrs</p>
                    <p className="title-row">+60 hrs</p>
                    <p className="title-row bg-gray">Fantasmas</p>
                    <p className="title-row">Facturas duplicadas</p>
                    <p className="title-row bg-gray">% Efectividad</p>
                </div>
                <div className="td-scroll-row">
                    <table>
                        <thead>
                            <tr className="dt-title-table">
                                {loading ? (
                                    <td>Cargando...</td>
                                ) : (
                                    dates.map((date, key) => (
                                        <th className="header-th" key={`${date.last_year_digit}-${date.num_semana}`} >
                                            <p id={`head${key+1}`}>{date.last_year_digit}{date.num_semana.toString().padStart(2, '0')}</p>
                                            <p className="dd-date">
                                                {date.primer_dia} {date.mes_primer_dia} - 
                                                {date.ultimo_dia} {date.mes_ultimo_dia}
                                            </p>
                                        </th>
                                    ))
                                )}

                            </tr>
                        </thead>

                        <tbody>
                            <tr className="dt-content-table bg-gray">
                                <td id="vo_1">-</td>
                                <td id="vo_2">-</td>
                                <td id="vo_3">-</td>
                                <td id="vo_4">-</td>
                                <td id="vo_5">-</td>
                                <td id="vo_6">-</td>
                                <td id="vo_7">-</td>
                                <td id="vo_8">-</td>
                                <td id="vo_9">-</td>
                                <td id="vo_10">-</td>
                                <td id="vo_11">-</td>
                                <td id="vo_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="vf_1">-</td>
                                <td id="vf_2">-</td>
                                <td id="vf_3">-</td>
                                <td id="vf_4">-</td>
                                <td id="vf_5">-</td>
                                <td id="vf_6">-</td>
                                <td id="vf_7">-</td>
                                <td id="vf_8">-</td>
                                <td id="vf_9">-</td>
                                <td id="vf_10">-</td>
                                <td id="vf_11">-</td>
                                <td id="vf_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="vfp_1">-</td>
                                <td id="vfp_2">-</td>
                                <td id="vfp_3">-</td>
                                <td id="vfp_4">-</td>
                                <td id="vfp_5">-</td>
                                <td id="vfp_6">-</td>
                                <td id="vfp_7">-</td>
                                <td id="vfp_8">-</td>
                                <td id="vfp_9">-</td>
                                <td id="vfp_10">-</td>
                                <td id="vfp_11">-</td>
                                <td id="vfp_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="vnf_1">-</td>
                                <td id="vnf_2">-</td>
                                <td id="vnf_3">-</td>
                                <td id="vnf_4">-</td>
                                <td id="vnf_5">-</td>
                                <td id="vnf_6">-</td>
                                <td id="vnf_7">-</td>
                                <td id="vnf_8">-</td>
                                <td id="vnf_9">-</td>
                                <td id="vnf_10">-</td>
                                <td id="vnf_11">-</td>
                                <td id="vnf_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="est_1">-</td>
                                <td id="est_2">-</td>
                                <td id="est_3">-</td>
                                <td id="est_4">-</td>
                                <td id="est_5">-</td>
                                <td id="est_6">-</td>
                                <td id="est_7">-</td>
                                <td id="est_8">-</td>
                                <td id="est_9">-</td>
                                <td id="est_10">-</td>
                                <td id="est_11">-</td>
                                <td id="est_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="mex_dom_1">-</td>
                                <td id="mex_dom_2">-</td>
                                <td id="mex_dom_3">-</td>
                                <td id="mex_dom_4">-</td>
                                <td id="mex_dom_5">-</td>
                                <td id="mex_dom_6">-</td>
                                <td id="mex_dom_7">-</td>
                                <td id="mex_dom_8">-</td>
                                <td id="mex_dom_9">-</td>
                                <td id="mex_dom_10">-</td>
                                <td id="mex_dom_11">-</td>
                                <td id="mex_dom_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="mex_expo1">-</td>
                                <td id="mex_expo2">-</td>
                                <td id="mex_expo3">-</td>
                                <td id="mex_expo4">-</td>
                                <td id="mex_expo5">-</td>
                                <td id="mex_expo6">-</td>
                                <td id="mex_expo7">-</td>
                                <td id="mex_expo8">-</td>
                                <td id="mex_expo9">-</td>
                                <td id="mex_expo10">-</td>
                                <td id="mex_expo11">-</td>
                                <td id="mex_expo12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="impo_1">-</td>
                                <td id="impo_2">-</td>
                                <td id="impo_3">-</td>
                                <td id="impo_4">-</td>
                                <td id="impo_5">-</td>
                                <td id="impo_6">-</td>
                                <td id="impo_7">-</td>
                                <td id="impo_8">-</td>
                                <td id="impo_9">-</td>
                                <td id="impo_10">-</td>
                                <td id="impo_11">-</td>
                                <td id="impo_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="vap_1">-</td>
                                <td id="vap_2">-</td>
                                <td id="vap_3">-</td>
                                <td id="vap_4">-</td>
                                <td id="vap_5">-</td>
                                <td id="vap_6">-</td>
                                <td id="vap_7">-</td>
                                <td id="vap_8">-</td>
                                <td id="vap_9">-</td>
                                <td id="vap_10">-</td>
                                <td id="vap_11">-</td>
                                <td id="vap_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="entiempo_1">-</td>
                                <td id="entiempo_2">-</td>
                                <td id="entiempo_3">-</td>
                                <td id="entiempo_4">-</td>
                                <td id="entiempo_5">-</td>
                                <td id="entiempo_6">-</td>
                                <td id="entiempo_7">-</td>
                                <td id="entiempo_8">-</td>
                                <td id="entiempo_9">-</td>
                                <td id="entiempo_10">-</td>
                                <td id="entiempo_11">-</td>
                                <td id="entiempo_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="24h_1">-</td>
                                <td id="24h_2">-</td>
                                <td id="24h_3">-</td>
                                <td id="24h_4">-</td>
                                <td id="24h_5">-</td>
                                <td id="24h_6">-</td>
                                <td id="24h_7">-</td>
                                <td id="24h_8">-</td>
                                <td id="24h_9">-</td>
                                <td id="24h_10">-</td>
                                <td id="24h_11">-</td>
                                <td id="24h_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="60m_1">-</td>
                                <td id="60m_2">-</td>
                                <td id="60m_3">-</td>
                                <td id="60m_4">-</td>
                                <td id="60m_5">-</td>
                                <td id="60m_6">-</td>
                                <td id="60m_7">-</td>
                                <td id="60m_8">-</td>
                                <td id="60m_9">-</td>
                                <td id="60m_10">-</td>
                                <td id="60m_11">-</td>
                                <td id="60m_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="fant_1">-</td>
                                <td id="fant_2">-</td>
                                <td id="fant_3">-</td>
                                <td id="fant_4">-</td>
                                <td id="fant_5">-</td>
                                <td id="fant_6">-</td>
                                <td id="fant_7">-</td>
                                <td id="fant_8">-</td>
                                <td id="fant_9">-</td>
                                <td id="fant_10">-</td>
                                <td id="fant_11">-</td>
                                <td id="fant_12">-</td>
                            </tr>
                            <tr className="dt-content-table">
                                <td id="fd_1">-</td>
                                <td id="fd_2">-</td>
                                <td id="fd_3">-</td>
                                <td id="fd_4">-</td>
                                <td id="fd_5">-</td>
                                <td id="fd_6">-</td>
                                <td id="fd_7">-</td>
                                <td id="fd_8">-</td>
                                <td id="fd_9">-</td>
                                <td id="fd_10">-</td>
                                <td id="fd_11">-</td>
                                <td id="fd_12">-</td>
                            </tr>
                            <tr className="dt-content-table bg-gray">
                                <td id="pe_1">-</td>
                                <td id="pe_2">-</td>
                                <td id="pe_3">-</td>
                                <td id="pe_4">-</td>
                                <td id="pe_5">-</td>
                                <td id="pe_6">-</td>
                                <td id="pe_7">-</td>
                                <td id="pe_8">-</td>
                                <td id="pe_9">-</td>
                                <td id="pe_10">-</td>
                                <td id="pe_11">-</td>
                                <td id="pe_12">-</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {/*Graficas*/}
            <div className="container dd-container-chart">
                <div className="dd-card-container">
                    <div className="checked-flights">
                        <div className="checked-flights-details">
                            <p className="title">VUELOS NO FACTURADOS</p>
                            <div className="details">
                                <div className="item">
                                    <div className="color" style={{background: "#1942A1"}}></div>
                                    <p>Facturados</p>
                                </div>
                                <div className="item">
                                    <div className="color" style={{background: "#A5ACBB"}}></div>
                                    <p>No Facturados</p>
                                </div>
                            </div>
                        </div>
                        <div style={{width: '300px'}}>
                            <canvas style={{width: '100%'}} ref={chartRef}></canvas>
                        </div>
                    </div>
                </div>

                <div className="dd-card-container">
                    <div className="dd-chart-flys">
                        <h4>% EFECTIVIDAD VS % VUELOS</h4>
                        <div style={{width: '100%'}}>
                            <canvas style={{width: '100%'}} ref={chartRef2}></canvas>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default DataTable;